import type { ErrorInfo } from 'react'

import { logger } from './LoggerService'
import { captureReactError as _captureReactError } from './interceptors/errorInterceptor'

export { logger } from './LoggerService'
export { LoggerProvider } from './LoggerProvider'

// Bound version — callers don't need to pass the logger instance
export const captureReactError = (error: Error, info: ErrorInfo): void =>
  _captureReactError(logger, error, info)
